import { useEffect, useState } from 'react';

import { Banner } from '@betterment/samba-react';
import { useAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export type Flash = {
  message: string;
  variant: 'info' | 'success' | 'warning' | 'critical' | undefined;
};

export const flashAtom = atomWithStorage<Flash | null>(
  'flash',
  null,
  createJSONStorage(() => sessionStorage),
  { getOnInit: true }
);

export const FlashApp = () => {
  const [storedFlash, setStoredFlash] = useAtom(flashAtom);
  const [flash, setFlash] = useState<Flash | null>(null);

  useEffect(() => {
    if (!flash && storedFlash) {
      setFlash(storedFlash);
      setStoredFlash(null);
    }
  }, [flash, storedFlash, setStoredFlash]);

  return (
    flash && (
      <Banner variant={flash.variant} css={{ marginBottom: 'space.300' }}>
        {flash.message}
      </Banner>
    )
  );
};
